const Backbone = require('backbone');
const GroupedCollection = require('../extensions/grouped-collection.js');
const VirtualCollection = require('backbone-virtual-collection');
const moment = require('moment');
const $ = window.jQuery;
const _ = require('underscore');
const globalTime = require('../data/time.js');
const parameters = require('../data/parameters.js');

const numberOfWeeks = parameters.get('weeks_to_display');

// locale FR
require('moment/locale/fr');

module.exports = {
  getWeekBookings(bookings, time, studioIds) {
    bookings.fetch({
      data: {
        startDay: time.get('firstDay').format('YYYY-MM-DD'),
        endDay: time.get('lastDay').format('YYYY-MM-DD'),
        studioId: studioIds || null
      }
    });

    bookings.listenTo(time, 'change:currentWeek', function() {
      this.fetch({
        data: {
          startDay: time.get('firstDay').format('YYYY-MM-DD'),
          endDay: time.get('lastDay').format('YYYY-MM-DD'),
          studioId: studioIds || null
        }
      });
    });

    return bookings;
  },
  getFilteredBookings(bookings, filters) {
    const extractActivityIds = function(list, filter) {
      if (filter.get('active')) {
        return _.union(list, filter.get('activityIdList'));
      }
      return list;
    };

    let activityIds = filters.reduce(extractActivityIds, []);

    const filterFunction = function(model) {
      if (filters.findWhere({ active: true })) {
        return _.indexOf(activityIds, model.get('activity').id) !== -1;
      }
      return true;
    };

    const collection = new VirtualCollection(bookings, {
      filter: filterFunction
    });

    filters.on(
      'update change',
      _.debounce(() => {
        activityIds = filters.reduce(extractActivityIds, []);

        collection.updateFilter(filterFunction);
      })
    );

    return collection;
  },
  getSections(bookings) {
    const self = this;

    const sections = new GroupedCollection(bookings, {
      groupBy: 'section',
      sortOrder: 'ASC'
    });

    // init current groups
    sections.each(section => {
      section.set('hours', self.getHours(section.get('collection')));
    });

    // init future groups
    sections.on('add', section => {
      section.set('hours', self.getHours(section.get('collection')));
    });

    return sections;
  },
  getHours(bookings) {
    const self = this;

    const hours = new GroupedCollection(bookings, {
      groupBy: 'hour',
      sortOrder: 'ASC'
    });

    // init current groups
    hours.each(hour => {
      hour.set('days', self.getDays(hour.get('collection')));
    });

    // init future groups
    hours.on('add', hour => {
      hour.set('days', self.getDays(hour.get('collection')));
    });

    return hours;
  },
  getDays(bookings) {
    const days = new Backbone.Collection([
      { id: 1, name: 'Lundi' },
      { id: 2, name: 'Mardi' },
      { id: 3, name: 'Mercredi' },
      { id: 4, name: 'Jeudi' },
      { id: 5, name: 'Vendredi' },
      { id: 6, name: 'Samedi' },
      { id: 7, name: 'Dimanche' }
    ]);

    // init groups
    days.each(day => {
      day.set(
        'bookings',
        new VirtualCollection(bookings, {
          filter(booking) {
            return booking.get('day').toString() === day.id.toString();
          }
        })
      );
    });

    return days;
  },
  getCoursesCollection(dayBookings, time, next, offset, limit) {
    const self = this;

    const courses = this.getCoursesArray(dayBookings, time.get('currentDate'), next, offset, limit);

    const CoursesCollection = new Backbone.Collection();

    CoursesCollection.set(courses);

    CoursesCollection.listenTo(dayBookings, 'update', () => {
      const courses = self.getCoursesArray(dayBookings, time.get('currentDate'), next, offset, limit);

      CoursesCollection.set(courses);
    });

    CoursesCollection.listenTo(time, 'change:currentDate', () => {
      const courses = self.getCoursesArray(dayBookings, time.get('currentDate'), next, offset, limit);

      CoursesCollection.set(courses);
    });

    return CoursesCollection;
  },
  getCoursesArray(dayBookings, currentDate, next, offset, limit) {
    const self = this;
    let bookings = '';

    if (next) {
      bookings = this.getNextBookings(dayBookings, currentDate);
    } else {
      bookings = this.getCurrentBookings(dayBookings, currentDate);
    }

    const courses = [];
    let count = 0;

    bookings.forEach(booking => {
      count++;
      const activity = booking.get('activity');
      let activityDesc = '';
      if (activity.get('description')) {
        activityDesc = self.truncate(activity.get('description'), 150);
      }

      let coachName = '';
      if (booking.get('coach')) {
        coachName = booking.get('coach').get('name');
      }

      const studio = booking.get('studio');
      const studioName = studio.get('name');

      const bookingDate = booking.get('beginDate');
      const beginHour = moment(bookingDate).format('HH[H]mm');
      const differenceTime = bookingDate.getTime() - currentDate.getTime();
      const minutesRemaining = Math.round(differenceTime / 60000);

      const course = {
        activityColor: activity.get('color'),
        activityDesc,
        activityImageUrl: activity.get('imageUrl'),
        activityName: activity.get('name'),
        beginHour,
        coachName,
        studioName
      };

      if (next) {
        course.isNext = true;
      } else {
        course.isNext = false;
        course.minutesPassed = Math.abs(minutesRemaining);
      }

      if (count > offset && courses.length < limit) {
        courses.push(course);
      }
    });

    return courses;
  },
  getCurrentBookings(bookings, currentDate) {
    let currentBookings = bookings.filter(booking => {
      const bookingBeginDate = booking.get('beginDate');
      const bookingEndDate = booking.get('endDate');
      return bookingBeginDate <= currentDate && bookingEndDate > currentDate;
    });

    // remove canceled bookings from the collection
    currentBookings = currentBookings.filter(booking => !booking.get('suppressionDate'));

    return currentBookings;
  },
  getNextBookings(bookings, currentDate) {
    let nextBookings = bookings.filter(booking => {
      const bookingDate = booking.get('beginDate');
      if (bookingDate.getHours() === currentDate.getHours()) {
        return bookingDate.getMinutes() > currentDate.getMinutes();
      }
      return bookingDate.getHours() > currentDate.getHours();
    });

    // remove canceled bookings from the collection
    nextBookings = nextBookings.filter(booking => !booking.get('suppressionDate'));

    return nextBookings;
  },
  getFiltersToDisplay(filters) {
    filters.each(filter => {
      if (filter.get('activityIdList')[0]) {
        filter.set('enabled', true);
      } else {
        filter.set('disabled', false);
      }
    });

    return filters;
  },
  openFooterPopup() {
    const popupFooter = $('.popup_footer');
    /* preventing click */
    if (popupFooter.is(':animated')) {
      return;
    }

    popupFooter.css('display', 'block');

    const scrollInContent = $('body').scrollTop();

    $('.absolute').css('top', scrollInContent + 160);

    popupFooter.attr('class', 'popup_footer open');

    $('html').css({
      overflow: 'hidden',
      height: '100%'
    });

    $('.absolute').fadeIn('fast');

    $('.absolute').click(() => {
      const popupFooter = $('.popup_footer');

      if (popupFooter.css('display') === 'block') {
        popupFooter.attr('class', 'popup_footer close');

        setTimeout(() => {
          popupFooter.fadeOut('fast');

          $('.absolute').fadeOut('fast');

          $('html, body').css({
            overflow: 'auto',
            height: 'auto'
          });
        }, 900);
      }
    });
  },
  closeFooterPopup() {
    const popupFooter = $('.popup_footer');

    if (popupFooter.css('display') === 'block') {
      popupFooter.attr('class', 'popup_footer close');

      setTimeout(() => {
        popupFooter.fadeOut('fast');

        $('.absolute').fadeOut('fast');

        $('html, body').css({
          overflow: 'auto',
          height: 'auto'
        });
      }, 900);
    }
  },
  openActivityPopup() {
    $('html').css({
      overflow: 'hidden',
      height: '100%'
    });
  },
  closeActivityPopup() {
    const qtipFocus = $('.qtip-focus');
    if (qtipFocus) {
      qtipFocus.fadeOut('fast', function() {
        $(this).detach();
      });
    }

    $('html, body').css({
      overflow: 'auto',
      height: 'auto'
    });
  },
  displayPrevWeekAnim() {
    $('.owl-carousel').trigger('prev.owl.carousel');
  },
  displayNextWeekAnim() {
    $('.owl-carousel').trigger('next.owl.carousel');
  },
  displayChangeWeek() {
    if (globalTime.get('currentWeek') > 0) {
      $('.plg_left_arrow').attr('class', 'plg_left_arrow');
      setTimeout(() => {
        $('.plg_left_arrow').fadeTo('fast', 1);
      }, 200);
    } else {
      $('.plg_left_arrow').fadeTo('fast', 0);
    }

    if (globalTime.get('currentWeek') < numberOfWeeks - 1) {
      $('.plg_right_arrow').attr('class', 'plg_right_arrow');
      setTimeout(() => {
        $('.plg_right_arrow').fadeTo('fast', 1);
      }, 200);
    } else {
      $('.plg_right_arrow').fadeTo('fast', 0);
    }
  },
  displayFastLoading() {
    $('#app_container').attr('class', 'ajax');
    setTimeout(() => {
      $('#app_container').attr('class', '');
    }, 1000);
  },
  displayFooterActually() {
    $('.actuallynext').text('Actuellement');
  },
  displayFooterNext() {
    $('.actuallynext').text("Tout à l'heure");
  },
  scrollToCurrentBlock() {
    const currentHour = globalTime.get('currentDate').getHours();
    let scrollId = '';
    const scrollIds = ['#tot', '#matin', '#midi', '#apres-midi', '#soir'];

    switch (true) {
      case currentHour >= 0 && currentHour < 9:
        scrollId = scrollIds[0]; // #tot
        break;
      case currentHour > 8 && currentHour < 12:
        scrollId = scrollIds[1]; // #matin
        break;
      case currentHour === 12 || currentHour === 13:
        scrollId = scrollIds[2]; // #midi
        break;
      case currentHour > 13 && currentHour < 19:
        scrollId = scrollIds[3]; // #apres-midi
        break;
      case currentHour > 18:
        scrollId = scrollIds[4]; // #soir
        break;
      default:
        break;
    }

    let tmpValue = 0;

    // If element with #id not found (for the scroll),
    // we try to found the next element in planning
    // example : if no "#tot" in DOM,
    // we change scrollId to "#matin", if not found, to "#midi" ...
    // if no elements found, we set scrollId to ".content" class
    while ($(scrollId).length === 0 && scrollId !== null) {
      const index = scrollIds.indexOf(scrollId);
      if (index === 0 && tmpValue > scrollIds.length) {
        scrollId = '.content';
      } else if (index + 1 < scrollIds.length) {
        scrollId = scrollIds[index + 1];
      } else {
        scrollId = scrollIds[0];
      }
      tmpValue++;
    }

    $('html, body').animate(
      {
        scrollTop: $(scrollId).offset().top - 285 // 260 is header height + 25px
      },
      2000
    );
  },
  animateOverflowBookings() {
    setTimeout(() => {
      $('.marquee').removeClass('marquee');
      const bookingsSpanList = $('.planning_part .right_pp span:nth-child(3)').toArray();
      $.each(bookingsSpanList, (index, value) => {
        if (value.offsetWidth < value.scrollWidth || value.offsetHeight < value.scrollHeight) {
          $(value).addClass('marquee');
        }
      });
    }, 10000);
  },
  truncate(string, maxLength) {
    // trim the string to the maximum length
    let truncatedString = string.substr(0, maxLength);

    // re-trim if we are in the middle of a word
    truncatedString = truncatedString.substr(0, Math.min(truncatedString.length, truncatedString.lastIndexOf(' ')));

    if (string.length > maxLength) {
      truncatedString += '...';
    }

    return truncatedString;
  }
};



// WEBPACK FOOTER //
// ./src/controllers/terminal.js